<template>
  <div class="checkout-section">
    <h2>CHECKOUT</h2>
    <div class="header-divider"></div>
    <div class="checkout-content">
      <div class="configuration-summary">
        <div class="config-details">
          <div class="config-item">
            <span class="config-label">Item</span>
            <span class="config-value">Black Tube Screamer</span>
          </div>
          <!-- Enclosure color fixed to black - not shown to customer -->
          <div class="config-item">
            <span class="config-label">Knob Color</span>
            <span class="config-value">{{ configurationData.knobColor }}</span>
          </div>
          <div class="config-item">
            <span class="config-label">LED</span>
            <span class="config-value">{{ configurationData.ledColor }}</span>
          </div>
        </div>
      </div>

      <button 
        @click="handleAddToCart"
        class="checkout-button"
      >
        Add to Cart
      </button>
    </div>


  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ConfigurationData, ShopifyConfigurationData, convertToShopifyFormat } from '@/utils/configurationHelper';

export default defineComponent({
  name: 'CheckoutButton',
  props: {
    configurationData: {
      type: Object as PropType<ConfigurationData>,
      required: true
    },
    productId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const handleAddToCart = () => {
      try {
        const shopifyConfig: ShopifyConfigurationData = convertToShopifyFormat(props.configurationData);
        
        const messageData = {
          type: 'ADD_TO_CART',
          payload: {
            productId: props.productId,
            quantity: 1,
            properties: shopifyConfig
          }
        };

        if (window.parent && window.parent !== window) {
          // Send message to Shopify - let Shopify handle everything
          window.parent.postMessage(messageData, '*');
        } else {
          // For local testing only
          console.log('Configuration to be sent to Shopify:', shopifyConfig);
        }

      } catch (error) {
        console.error('Error preparing cart data:', error);
      }
    };

    return {
      handleAddToCart
    };
  }
});
</script>

<style scoped>
.checkout-section {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 4.75rem;
  border: none;
}

.checkout-content {
  width: 65%;
  margin-left: 0;
  margin-right: auto;
}

h2 {
  font-size: 2.6833rem; /* 2.4394rem * 1.10 */
  margin: 0 0 0.55rem 0;
  color: rgb(0, 0, 0);
  font-weight: 400;
  letter-spacing: 0.000em;
}

.header-divider {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.35);
  margin: 0.35rem 0 2.079rem 0; /* 1.7325rem * 1.20 */
}

.config-details {
  margin-bottom: 1.2rem;
}

.config-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.55);
}

.config-item:last-child {
  border-bottom: none;
}

.config-label {
  font-family: "Cormorant Garamond", "Times New Roman", Times, serif;
  color: rgb(0, 0, 0);
  font-size: 1.26rem; /* 0.9rem * 1.40 */
  font-weight: 700;
}

.config-value {
  font-family: "Cormorant Garamond", "Times New Roman", Times, serif;
  color: rgb(0, 0, 0);
  font-size: 1.12rem; /* 0.8rem * 1.40 */
  font-weight: 500;
  text-align: right;
}

.checkout-button {
  width: fit-content;
  padding: 0.75rem 2.4rem;
  background: rgb(0, 0, 0);
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 9999px;
  font-size: 1.575rem;
  font-weight: 400;
  font-family: "Unica One", "Inter", "Segoe UI", Arial, Helvetica, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.000em;
  cursor: pointer;
  transition: all 0.3s ease;
  display: block;
  margin: 2.3805rem auto 0; /* 2.07rem * 1.15 */
}

.checkout-button:hover:not(:disabled) {
  background: rgb(25, 25, 25);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}



@media screen and (max-width: 768px) {
  .checkout-section {
    padding: 0;
  }

  .checkout-content {
    width: 100%;
  }
  
  .checkout-button {
    padding: 0.8rem 2.2rem;
    font-size: 1.5rem;
  }
  
  .config-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .config-label {
    font-size: 1.008rem; /* 0.72rem * 1.40 */
  }
  
  .config-value {
    font-size: 1.008rem; /* 0.72rem * 1.40 */
    text-align: right;
  }
}
</style> 